import React from 'react';
export default function SquareHandlebarMustache({
  light,
  dark,
}) {
  return (
<><g fill={light}><path d="M17.223 17.139s-.774-1.48-1.804-1.51c-1.03-.028-1.469 1.44-2.346 1.39-.878-.05-1.705-1.498-1.705-1.498s.266 2.384 1.549 2.564c1.283.18 2.202-1.35 2.583-1.133.381.217 1.434.86 1.723.187z"/><path d="M16.967 17.139s.775-1.48 1.804-1.51c1.03-.028 1.469 1.44 2.347 1.39.878-.05 1.705-1.498 1.705-1.498s-.266 2.384-1.55 2.564c-1.282.18-2.201-1.35-2.582-1.133-.382.217-1.434.86-1.724.187z"/></g></>); }
